// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Design tokens ported from the reference analytics UI
   ========================================================= */
.dashboard_mobile_dashboard__WPstT {
  --navy: #1B2559;
  --navy-soft: #eef1fb;
  --orange: #F7941D;
  --orange-soft: #fdeedd;
  --indigo: #4F63D2;
  --indigo-soft: #eaedfb;
  --purple: #7C5CFC;
  --purple-soft: #f1edfe;
  --green: #22C55E;
  --green-soft: #e9f9ef;
  --blue: #3B82F6;
  --blue-soft: #eaf2fe;
  --bg: #F5F6FA;
  --card: #ffffff;
  --border: #E7E9F1;
  --text: #1F2430;
  --text-secondary: #6B7280;
  --text-muted: #9CA3AF;

  font-family: 'Inter', -apple-system, sans-serif;
  background: var(--bg);
  padding: 4px 28px 40px;
  animation: dashboard_dashFadeIn__3FK68 0.35s ease;
}

@keyframes dashboard_dashFadeIn__3FK68 {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* =========================================================
   Hero / welcome banner
   ========================================================= */
.dashboard_dashboardHero__745w- {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  border-radius: 18px;
  padding: 26px 30px;
  margin-bottom: 24px;
  box-shadow: 0 16px 34px rgba(76, 47, 179, 0.28);
}

.dashboard_dashboardHero__745w-::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -40px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

.dashboard_dashboardHero__745w-::after {
  content: "";
  position: absolute;
  bottom: -70px;
  right: 120px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  pointer-events: none;
}

.dashboard_heroTitle__D0Prx {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.01em;
}

.dashboard_heroSub__7V6eG {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.78);
  margin-top: 4px;
}

.dashboard_heroDateChip__0gVwp {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 12px;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}

/* =========================================================
   KPI cards
   ========================================================= */
.dashboard_kpiGrid__-ZNnb {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 18px;
  margin-bottom: 24px;
}

.dashboard_kpiCard__kAmiq {
  position: relative;
  overflow: hidden;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 20px 22px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  box-shadow: 0 2px 10px rgba(27, 37, 89, 0.05);
}
.dashboard_kpiCard__kAmiq::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #4c2fb3, #7c5cfc);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.dashboard_kpiCard__kAmiq:hover {
  box-shadow: 0 16px 32px rgba(76, 47, 179, 0.16);
  transform: translateY(-3px);
  border-color: rgba(124, 92, 252, 0.3);
}
.dashboard_kpiCard__kAmiq:hover::before {
  opacity: 1;
}

.dashboard_kpiTop__-6p3q {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}

.dashboard_kpiLabel__8FotG {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.4;
  max-width: 120px;
}

.dashboard_kpiIcon__6CoIU {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid var(--border);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.dashboard_kpiCard__kAmiq:hover .dashboard_kpiIcon__6CoIU {
  transform: scale(1.06);
}
.dashboard_tint_indigo__9Zpyk { box-shadow: 0 6px 16px rgba(79, 99, 210, 0.28); }
.dashboard_tint_purple__FTIYa { box-shadow: 0 6px 16px rgba(124, 92, 252, 0.28); }
.dashboard_tint_green__xX0Pc  { box-shadow: 0 6px 16px rgba(34, 197, 94, 0.26); }
.dashboard_tint_orange__-2olS { box-shadow: 0 6px 16px rgba(247, 148, 29, 0.26); }
.dashboard_tint_blue__AeQdE   { box-shadow: 0 6px 16px rgba(59, 130, 246, 0.26); }

.dashboard_kpiValue__3jtuO {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: var(--navy);
  letter-spacing: -0.01em;
}

.dashboard_kpiSub__--cBv {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}

/* legacy classnames still referenced elsewhere in the component */
.dashboard_cardSttyle__JwJfm { border-radius: 12px; }
.dashboard_cardHeading__yWWU9 { font-size: 12.5px; font-weight: 600; color: #6B7280; text-transform: uppercase; }
.dashboard_count__nJN3A { font-family: 'Sora', 'Inter', sans-serif; color: #1B2559; }
.dashboard_iconColor__xbtwS { color: #4F63D2; }

/* =========================================================
   Chart panels
   ========================================================= */
.dashboard_chartsGrid__xfIB\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
}
@media (max-width: 900px) {
  .dashboard_chartsGrid__xfIB\\+ { flex-direction: column; }
  .dashboard_panel__csNBy { width: 100%; }
}

.dashboard_panel__csNBy {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 20px 25px;
  flex: 1 1 420px;
  min-width: 0;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);
  transition: box-shadow 0.2s ease;
}
.dashboard_panel__csNBy:hover {
  box-shadow: 0 10px 26px rgba(76, 47, 179, 0.1);
}

.dashboard_panelHead__BHqek {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.dashboard_panelTitle__UxlU0 {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 15.5px;
  font-weight: 600;
  color: var(--text);
}

.dashboard_panelSub__yb4oa {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
  margin-bottom: 14px;
}

.dashboard_panelSelect__6gog1 {
  background: var(--indigo-soft);
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 12px;
  transition: background 0.15s ease;
}
.dashboard_panelSelect__6gog1:hover {
  background: var(--purple-soft);
}

.dashboard_legend__GR6n9 {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 6px;
}
.dashboard_legendItem__pbRw2 {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: var(--text-secondary);
}
.dashboard_legendItem__pbRw2 b { color: var(--text); font-weight: 600; margin-left: 2px; }
.dashboard_legendDot__FjQzz { width: 9px; height: 9px; border-radius: 2px; flex-shrink: 0; display: inline-block; }

.dashboard_donutWrap__0FH87 { position: relative; width: 220px; height: 220px; max-width: 100%; display: flex; align-items: center; justify-content: center; }
.dashboard_donutCenter__wbUIZ {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}
.dashboard_donutCenter__wbUIZ .n {
  display: block;
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--navy);
}
.dashboard_donutCenter__wbUIZ .l {
  display: block;
  font-size: 11px;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.dashboard_emptyState__uJcwN {
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
  padding: 24px 0;
}

/* legacy classnames still referenced elsewhere (kept for the graphMain wrapper / calendar chip / colour legend used in unmodified sections) */
.dashboard_graphMain__MepwA { display: flex; gap: 20px; width: 100%; flex-wrap: wrap; }
.dashboard_lineGraphMain__DUvfQ { background: var(--card); border: 1px solid var(--border); border-radius: 14px; padding: 18px 20px; flex: 1 1; min-width: 280px; }
.dashboard_graphHeading__WgH3v { font-family: 'Sora', 'Inter', sans-serif; font-size: 15px; font-weight: 600; color: var(--text); }
.dashboard_calenderstyle__J11yM { background: var(--navy-soft); color: var(--navy); border-radius: 10px; padding: 4px 10px; font-size: 12.5px; display: inline-flex; align-items: center; gap: 4px; }
.dashboard_colourCode__BXkqH { width: 12px; height: 12px; border-radius: 3px; background: var(--indigo); }
.dashboard_lineGraph__uG35H { background: var(--card); border: 1px solid var(--border); border-radius: 14px; padding: 18px 20px; width: 320px; }

/* =========================================================
   Mobile
   ========================================================= */
.dashboard_showOnDesktop__OmbLT { display: block; }
.dashboard_showOnMobile__Clkgx { display: none; }
@media (max-width: 768px) {
  .dashboard_showOnDesktop__OmbLT { display: none; }
  .dashboard_showOnMobile__Clkgx { display: block; }
}

.dashboard_mobileBoxes__7j4vZ { background: var(--card); border: 1px solid var(--border); border-radius: 14px; min-width: 0; box-sizing: border-box; box-shadow: 0 2px 10px rgba(27, 37, 89, 0.05); }
.dashboard_counti__m\\+PRe { font-family: 'Sora', 'Inter', sans-serif; font-size: 20px; font-weight: 700; color: var(--navy); }
.dashboard_orderBreakdowntexts__xwpDh { font-size: 12.5px; color: var(--text-secondary); font-weight: 600; margin-bottom: 2px; }
.dashboard_spinnerBox__b9rkN { width: 70px; height: 70px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; color: var(--navy); }`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.module.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;;EAErB,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,iDAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,0EAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,qDAAqD;AACvD;AACA;EACE,sBAAsB;AACxB;AACA,gCAAe,8CAA8C,EAAE;AAC/D,gCAAe,+CAA+C,EAAE;AAChE,gCAAe,8CAA8C,EAAE;AAC/D,gCAAe,+CAA+C,EAAE;AAChE,gCAAe,+CAA+C,EAAE;;AAEhE;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA,kEAAkE;AAClE,+BAAc,mBAAmB,EAAE;AACnC,gCAAe,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC/F,0BAAS,wCAAwC,EAAE,cAAc,EAAE;AACnE,8BAAa,cAAc,EAAE;;AAE7B;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE,gCAAc,sBAAsB,EAAE;EACtC,0BAAS,WAAW,EAAE;AACxB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,gCAAgC;AAClC;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;AACA,iCAAgB,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACxE,8BAAa,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAEjG,8BAAa,kBAAkB,EAAE,YAAY,EAAE,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC5I;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA,8IAA8I;AAC9I,8BAAa,aAAa,EAAE,SAAS,EAAE,WAAW,EAAE,eAAe,EAAE;AACrE,kCAAiB,uBAAuB,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,SAAO,EAAE,gBAAgB,EAAE;AAC/I,iCAAgB,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACjH,kCAAiB,4BAA4B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnL,+BAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACxF,8BAAa,uBAAuB,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,YAAY,EAAE;;AAE9H;;8DAE8D;AAC9D,kCAAiB,cAAc,EAAE;AACjC,iCAAgB,aAAa,EAAE;AAC/B;EACE,kCAAiB,aAAa,EAAE;EAChC,iCAAgB,cAAc,EAAE;AAClC;;AAEA,gCAAe,uBAAuB,EAAE,+BAA+B,EAAE,mBAAmB,EAAE,YAAY,EAAE,sBAAsB,EAAE,6CAA6C,EAAE;AACnL,4BAAU,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3G,wCAAuB,iBAAiB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9G,+BAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE","sourcesContent":["/* =========================================================\n   Design tokens ported from the reference analytics UI\n   ========================================================= */\n.mobile_dashboard {\n  --navy: #1B2559;\n  --navy-soft: #eef1fb;\n  --orange: #F7941D;\n  --orange-soft: #fdeedd;\n  --indigo: #4F63D2;\n  --indigo-soft: #eaedfb;\n  --purple: #7C5CFC;\n  --purple-soft: #f1edfe;\n  --green: #22C55E;\n  --green-soft: #e9f9ef;\n  --blue: #3B82F6;\n  --blue-soft: #eaf2fe;\n  --bg: #F5F6FA;\n  --card: #ffffff;\n  --border: #E7E9F1;\n  --text: #1F2430;\n  --text-secondary: #6B7280;\n  --text-muted: #9CA3AF;\n\n  font-family: 'Inter', -apple-system, sans-serif;\n  background: var(--bg);\n  padding: 4px 28px 40px;\n  animation: dashFadeIn 0.35s ease;\n}\n\n@keyframes dashFadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* =========================================================\n   Hero / welcome banner\n   ========================================================= */\n.dashboardHero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  border-radius: 18px;\n  padding: 26px 30px;\n  margin-bottom: 24px;\n  box-shadow: 0 16px 34px rgba(76, 47, 179, 0.28);\n}\n\n.dashboardHero::before {\n  content: \"\";\n  position: absolute;\n  top: -60px;\n  right: -40px;\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  pointer-events: none;\n}\n\n.dashboardHero::after {\n  content: \"\";\n  position: absolute;\n  bottom: -70px;\n  right: 120px;\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  pointer-events: none;\n}\n\n.heroTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: -0.01em;\n}\n\n.heroSub {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.78);\n  margin-top: 4px;\n}\n\n.heroDateChip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 16px;\n  border-radius: 12px;\n  backdrop-filter: blur(6px);\n}\n\n/* =========================================================\n   KPI cards\n   ========================================================= */\n.kpiGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 18px;\n  margin-bottom: 24px;\n}\n\n.kpiCard {\n  position: relative;\n  overflow: hidden;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 20px 22px;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n  box-shadow: 0 2px 10px rgba(27, 37, 89, 0.05);\n}\n.kpiCard::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #4c2fb3, #7c5cfc);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n.kpiCard:hover {\n  box-shadow: 0 16px 32px rgba(76, 47, 179, 0.16);\n  transform: translateY(-3px);\n  border-color: rgba(124, 92, 252, 0.3);\n}\n.kpiCard:hover::before {\n  opacity: 1;\n}\n\n.kpiTop {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.kpiLabel {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.4;\n  max-width: 120px;\n}\n\n.kpiIcon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #ffffff;\n  border: 1px solid var(--border);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n.kpiCard:hover .kpiIcon {\n  transform: scale(1.06);\n}\n.tint_indigo { box-shadow: 0 6px 16px rgba(79, 99, 210, 0.28); }\n.tint_purple { box-shadow: 0 6px 16px rgba(124, 92, 252, 0.28); }\n.tint_green  { box-shadow: 0 6px 16px rgba(34, 197, 94, 0.26); }\n.tint_orange { box-shadow: 0 6px 16px rgba(247, 148, 29, 0.26); }\n.tint_blue   { box-shadow: 0 6px 16px rgba(59, 130, 246, 0.26); }\n\n.kpiValue {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--navy);\n  letter-spacing: -0.01em;\n}\n\n.kpiSub {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n/* legacy classnames still referenced elsewhere in the component */\n.cardSttyle { border-radius: 12px; }\n.cardHeading { font-size: 12.5px; font-weight: 600; color: #6B7280; text-transform: uppercase; }\n.count { font-family: 'Sora', 'Inter', sans-serif; color: #1B2559; }\n.iconColor { color: #4F63D2; }\n\n/* =========================================================\n   Chart panels\n   ========================================================= */\n.chartsGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  width: 100%;\n}\n@media (max-width: 900px) {\n  .chartsGrid { flex-direction: column; }\n  .panel { width: 100%; }\n}\n\n.panel {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 20px 25px;\n  flex: 1 1 420px;\n  min-width: 0;\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 12px rgba(27, 37, 89, 0.05);\n  transition: box-shadow 0.2s ease;\n}\n.panel:hover {\n  box-shadow: 0 10px 26px rgba(76, 47, 179, 0.1);\n}\n\n.panelHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.panelTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 15.5px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.panelSub {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n  margin-bottom: 14px;\n}\n\n.panelSelect {\n  background: var(--indigo-soft);\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 7px 12px;\n  transition: background 0.15s ease;\n}\n.panelSelect:hover {\n  background: var(--purple-soft);\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 6px;\n}\n.legendItem {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n.legendItem b { color: var(--text); font-weight: 600; margin-left: 2px; }\n.legendDot { width: 9px; height: 9px; border-radius: 2px; flex-shrink: 0; display: inline-block; }\n\n.donutWrap { position: relative; width: 220px; height: 220px; max-width: 100%; display: flex; align-items: center; justify-content: center; }\n.donutCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n}\n.donutCenter :global(.n) {\n  display: block;\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--navy);\n}\n.donutCenter :global(.l) {\n  display: block;\n  font-size: 11px;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.emptyState {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 13px;\n  padding: 24px 0;\n}\n\n/* legacy classnames still referenced elsewhere (kept for the graphMain wrapper / calendar chip / colour legend used in unmodified sections) */\n.graphMain { display: flex; gap: 20px; width: 100%; flex-wrap: wrap; }\n.lineGraphMain { background: var(--card); border: 1px solid var(--border); border-radius: 14px; padding: 18px 20px; flex: 1; min-width: 280px; }\n.graphHeading { font-family: 'Sora', 'Inter', sans-serif; font-size: 15px; font-weight: 600; color: var(--text); }\n.calenderstyle { background: var(--navy-soft); color: var(--navy); border-radius: 10px; padding: 4px 10px; font-size: 12.5px; display: inline-flex; align-items: center; gap: 4px; }\n.colourCode { width: 12px; height: 12px; border-radius: 3px; background: var(--indigo); }\n.lineGraph { background: var(--card); border: 1px solid var(--border); border-radius: 14px; padding: 18px 20px; width: 320px; }\n\n/* =========================================================\n   Mobile\n   ========================================================= */\n.showOnDesktop { display: block; }\n.showOnMobile { display: none; }\n@media (max-width: 768px) {\n  .showOnDesktop { display: none; }\n  .showOnMobile { display: block; }\n}\n\n.mobileBoxes { background: var(--card); border: 1px solid var(--border); border-radius: 14px; min-width: 0; box-sizing: border-box; box-shadow: 0 2px 10px rgba(27, 37, 89, 0.05); }\n.counti { font-family: 'Sora', 'Inter', sans-serif; font-size: 20px; font-weight: 700; color: var(--navy); }\n.orderBreakdowntexts { font-size: 12.5px; color: var(--text-secondary); font-weight: 600; margin-bottom: 2px; }\n.spinnerBox { width: 70px; height: 70px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; color: var(--navy); }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_dashboard": `dashboard_mobile_dashboard__WPstT`,
	"dashFadeIn": `dashboard_dashFadeIn__3FK68`,
	"dashboardHero": `dashboard_dashboardHero__745w-`,
	"heroTitle": `dashboard_heroTitle__D0Prx`,
	"heroSub": `dashboard_heroSub__7V6eG`,
	"heroDateChip": `dashboard_heroDateChip__0gVwp`,
	"kpiGrid": `dashboard_kpiGrid__-ZNnb`,
	"kpiCard": `dashboard_kpiCard__kAmiq`,
	"kpiTop": `dashboard_kpiTop__-6p3q`,
	"kpiLabel": `dashboard_kpiLabel__8FotG`,
	"kpiIcon": `dashboard_kpiIcon__6CoIU`,
	"tint_indigo": `dashboard_tint_indigo__9Zpyk`,
	"tint_purple": `dashboard_tint_purple__FTIYa`,
	"tint_green": `dashboard_tint_green__xX0Pc`,
	"tint_orange": `dashboard_tint_orange__-2olS`,
	"tint_blue": `dashboard_tint_blue__AeQdE`,
	"kpiValue": `dashboard_kpiValue__3jtuO`,
	"kpiSub": `dashboard_kpiSub__--cBv`,
	"cardSttyle": `dashboard_cardSttyle__JwJfm`,
	"cardHeading": `dashboard_cardHeading__yWWU9`,
	"count": `dashboard_count__nJN3A`,
	"iconColor": `dashboard_iconColor__xbtwS`,
	"chartsGrid": `dashboard_chartsGrid__xfIB+`,
	"panel": `dashboard_panel__csNBy`,
	"panelHead": `dashboard_panelHead__BHqek`,
	"panelTitle": `dashboard_panelTitle__UxlU0`,
	"panelSub": `dashboard_panelSub__yb4oa`,
	"panelSelect": `dashboard_panelSelect__6gog1`,
	"legend": `dashboard_legend__GR6n9`,
	"legendItem": `dashboard_legendItem__pbRw2`,
	"legendDot": `dashboard_legendDot__FjQzz`,
	"donutWrap": `dashboard_donutWrap__0FH87`,
	"donutCenter": `dashboard_donutCenter__wbUIZ`,
	"emptyState": `dashboard_emptyState__uJcwN`,
	"graphMain": `dashboard_graphMain__MepwA`,
	"lineGraphMain": `dashboard_lineGraphMain__DUvfQ`,
	"graphHeading": `dashboard_graphHeading__WgH3v`,
	"calenderstyle": `dashboard_calenderstyle__J11yM`,
	"colourCode": `dashboard_colourCode__BXkqH`,
	"lineGraph": `dashboard_lineGraph__uG35H`,
	"showOnDesktop": `dashboard_showOnDesktop__OmbLT`,
	"showOnMobile": `dashboard_showOnMobile__Clkgx`,
	"mobileBoxes": `dashboard_mobileBoxes__7j4vZ`,
	"counti": `dashboard_counti__m+PRe`,
	"orderBreakdowntexts": `dashboard_orderBreakdowntexts__xwpDh`,
	"spinnerBox": `dashboard_spinnerBox__b9rkN`
};
export default ___CSS_LOADER_EXPORT___;
